import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { AuthProvider } from './auth/AuthContext'
import { Layout } from './components/Layout'
import {
  AccountLayout,
  AccountNotificationsPage,
  AccountOrdersPage,
  AccountOtherPage,
  AccountQueuePage,
} from './pages/AccountPage'
import { DepositPage, DepositPayPage } from './pages/DepositPage'
import {
  DownloadPage,
  KnowledgeBasePage,
  ResourcePacksPage,
  ServerListPage,
} from './pages/ContentPages'
import { OrderKeyPage } from './pages/OrderKeyPage'
import { AdminKeyIntroPage } from './pages/AdminKeyIntroPage'
import {
  AdminCardsPage,
  AdminDepositsPage,
  AdminHomePage,
  AdminLayout,
  AdminLookupPage,
  AdminMembersPage,
  AdminPendingOrdersPage,
  AdminQueuePage,
  AdminReviewsPage,
} from './pages/AdminPages'
import { GoogleDonePage, LoginPage, RegisterPage } from './pages/AuthPages'
import { BlogDetailPage, BlogListPage } from './pages/BlogPages'
import { BuyItForMePage } from './pages/BuyItForMePage'
import { BuyKeyPage } from './pages/BuyKeyPage'
import { CapePage } from './pages/CapePage'
import { CatalogListPage } from './pages/CatalogListPage'
import { CheckoutPage } from './pages/CheckoutPage'
import { DigitalShopPage } from './pages/DigitalShopPage'
import { HomePage } from './pages/HomePage'
import { MinecoinPage } from './pages/MinecoinPage'
import { ProductPage } from './pages/ProductPage'
import { ReviewsPage } from './pages/ReviewsPage'

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="login" element={<LoginPage />} />
          <Route path="register" element={<RegisterPage />} />
          <Route path="auth/google" element={<GoogleDonePage />} />
          <Route element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="mua-minecraft" element={<BuyKeyPage />} />
            <Route path="san-pham/:slug" element={<ProductPage />} />
            <Route path="danh-sach-san-pham" element={<CatalogListPage />} />
            <Route path="buyitforme" element={<BuyItForMePage />} />
            <Route path="buyitforme/:sourceId" element={<BuyItForMePage />} />
            <Route path="cape" element={<CapePage />} />
            <Route path="minecoin" element={<MinecoinPage />} />
            <Route path="digital-shop" element={<DigitalShopPage />} />
            <Route path="tai-nguyen" element={<ResourcePacksPage />} />
            <Route path="shader-pack" element={<ResourcePacksPage shader key="shader" />} />
            <Route path="tai-game" element={<DownloadPage />} />
            <Route path="faq" element={<KnowledgeBasePage />} />
            <Route path="may-chu-minecraft" element={<ServerListPage />} />
            <Route path="blog" element={<BlogListPage />} />
            <Route path="blog/:uri" element={<BlogDetailPage />} />
            <Route path="reviews" element={<ReviewsPage />} />
            <Route path="account" element={<AccountLayout />}>
              <Route index element={<AccountOrdersPage />} />
              <Route path="dat-ho" element={<AccountQueuePage />} />
              <Route path="thong-bao" element={<AccountNotificationsPage />} />
              <Route path="khac" element={<AccountOtherPage />} />
            </Route>
            <Route path="account/don/:id" element={<OrderKeyPage />} />
            <Route path="deposit" element={<DepositPage />} />
            <Route path="deposit/:id" element={<DepositPayPage />} />
            <Route path="checkout/:id" element={<CheckoutPage />} />
            <Route path="admin" element={<AdminLayout />}>
              <Route index element={<AdminHomePage />} />
              <Route path="reviews" element={<AdminReviewsPage />} />
              <Route path="dat-ho" element={<AdminQueuePage key="queue" />} />
              <Route path="tra-cuu-dat-ho" element={<AdminQueuePage key="queue-lookup" lookup />} />
              <Route path="don-cho" element={<AdminPendingOrdersPage />} />
              <Route path="chuyen-khoan" element={<AdminDepositsPage />} />
              <Route path="the-cao" element={<AdminCardsPage />} />
              <Route path="tra-cuu" element={<AdminLookupPage />} />
              <Route path="thanh-vien" element={<AdminMembersPage />} />
              <Route path="key-intro" element={<AdminKeyIntroPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}
